import {
  SEARCH_RESULT_FOUND_FOR,
  SEARCH_RESULTS_FOUND_FOR,
  translate,
} from "shared/utils/translate";
import { useRouter } from "next/router";
import styles from "./SearchResultContainer.module.css";

export const SearchResultContainer = ({ children, total, query }) => {
  const { locale } = useRouter();

  if (!query.trim().length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {total}{" "}
        {translate(
          total !== 1 ? SEARCH_RESULTS_FOUND_FOR : SEARCH_RESULT_FOUND_FOR,
          locale
        )}{" "}
        ‘{query}’
      </div>
      <div className={styles.childrenContainer}>{children}</div>
    </div>
  );
};
